<template>
    <ProductGallery
        v-show="products.length > 0"
        tag="li"
        class="product-gallery-item-wrapper full-span-item"
        :header1="item.segment.title ?? undefined"
        :products="products"
    ></ProductGallery>
    <li class="gallery-separator">
        <hr />
    </li>
</template>

<style scoped lang="scss">
@import "common.css.src/mixins.scss";
.product-gallery-item-wrapper {
    column-span: all;
    grid-column: 1/-1;
    max-width: 100%;
    margin-right: 0;
    &::v-deep .product-gallery-item {
        // width: calc(100% / 1.75) !important;
        width: 230px;
        // @include media-breakpoint-down(sm) {
        //     width: calc(100% / 1.75) !important;
        // }

        // @include media-breakpoint-up(md) {
        //     width: calc(100% / 2.75) !important;
        // }

        @include when-desktop() {
            width: calc(100% / 4.25) !important;
        }
    }

    @include when-desktop() {
        max-width: 755px;
    }
}

.gallery-separator {
    margin: 0;
    padding: 0;
    border: none;
    column-span: all;
    grid-column: 1/-1;
    hr {
        margin: 0;
        margin-bottom: 5px;
        padding: 0;
        border: none;
        border-top: 1px solid #464646;
    }

    @include when-desktop() {
        display: none;
    }
}
</style>

<script setup lang="ts">
import { ref } from "vue";
import ProductGallery from "../../../../frontend-productgallery/ProductGallery.vue";
import { ProductGalleryItem } from "../../list-item";

const props = defineProps({
    item: {
        type: ProductGalleryItem,
        required: true,
    },
});

const products = ref(props.item.segment.products);
</script>
